import { getBasePath } from '../config/basePath'

/**
 * Client-side redirect that prefixes the app basePath for relative paths.
 * No-op during SSR.
 */
export const redirectWithBasePath = (destination: string) => {
  if (typeof window === 'undefined') return

  const basePath = getBasePath()
  window.location.href = destination.startsWith('/')
    ? `${basePath}${destination}`
    : destination
}
